import React, { useState, useEffect } from 'react'

const Sidebar = ({ currentStep = 1, onSelectStep, completedSteps = [], totalSteps = 4, isMobileMenuOpen, setIsMobileMenuOpen }) => {

  // Close mobile menu when screen resizes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 993) {
        setIsMobileMenuOpen(false)
        document.body.classList.remove('mobile-menu-open')
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Handle body scroll lock
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('mobile-menu-open')
    } else {
      document.body.classList.remove('mobile-menu-open')
    }
  }, [isMobileMenuOpen])

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  const SidebarContent = () => (
    <div className="h-full flex flex-col items-center py-6">
      <div className="mb-8">
        <img 
          src="./../assets/images/Logo-Incredible-Leaders.png" 
          alt="Incredible Leaders" 
          className="w-full h-auto"
        />
      </div>

      <div className="flex flex-col items-center space-y-8">
        {Array.from({ length: totalSteps }).map((_, idx) => {
          const step = idx + 1
          const isActive = step === currentStep
          const isDone = completedSteps.includes(step)
          
          return (
            <div key={step} className="flex flex-col items-center">
              <button 
                className="cursor-default"
              >
                <div className={`w-[60px] h-[60px] rounded-full flex items-center justify-center font-lato not-italic font-medium text-[18px] leading-[150%] text-black transition-colors border-2 ${
                  isActive 
                    ? 'bg-[#FF8E1C] text-white border-[#FF8E1C]' 
                    : isDone 
                      ? 'bg-[#FF8E1C] text-white border-[#FF8E1C]'
                      : 'bg-white text-[#000000] border-[#FF8E1C] group-hover:bg-[#FFF6EB]'
                }`}>
                  {String(step).padStart(2, '0')}
                </div>
              </button>
              
              <div className="mt-2">
                <span className={`font-lato not-italic font-medium text-[16px] leading-[150%] mobile_fix ${
                  isActive || isDone
                    ? 'text-[#FF8E1C]' 
                    : 'text-[#000000]-600'
                }`}>
                  Step {step}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )

  return (
    <>
      {/* Desktop Sidebar - Shows above 993px */}
      <aside className="w-[150px] min-h-screen bg-[#FFF6EB] md-993:block hidden">
        <SidebarContent />
      </aside>

      {/* Mobile Sidebar Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-sidebar-overlay"
          onClick={closeMobileMenu}
        >
          <div 
            className="mobile-sidebar-container w-[280px] h-full bg-white"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-[#FFF6EB] h-full">
              <SidebarContent />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Sidebar